import React from 'react'
import '../css/mission.css'

function mission() {
  return (
    <div>
      {/* <h1> Mission page</h1>*/}


      <div className='mission-main'>
        <div className='left-side'>
        <div className='content-box'>
        <p>Sanskar School aims to:</p>
        <p>संस्कार स्कूल के लक्ष्य :</p>
        <p>L’école Sanskar vise à :</p>
        <ul>
          <li>
            <p>equip its pupils with a critical and global outlook which will make them committed citizens of the world.</p>
            <p>अपने विद्यार्थियों को समालोचनात्मक और वैश्विक दृष्टिकोण द्वारा इस प्रकार समर्थ बनाना कि वे इस संसार के विकास हेतु प्रतिबद्ध नागरिक बन सकें |</p>
            <p>Doter ses élèves d’une vision critique et globale qui fera d’eux des citoyens du monde engages.</p>
          </li>
          <li>
            <p>recognize and channelize the potential of the pupil and develop thinking, communication, social, scientific and interpersonal skills.</p>
            <p>विद्यार्थियों की क्षमता को पहचानना व उनका सदुपयोग सिखाना | उनकी संचार, सामाजिक, वैज्ञानिक, अंतर्वैयक्तिक क्षमता तथा विचार शक्ति का विकास करना |</p>
            <p>Reconnaitre et canaliser le potentiel de l’élève et développer la communication de la pensée, les compétences en sciences sociales et interpersonnelles.</p>
          </li>
          <li>
            <p>foster cognitive, affective and psychomotor development and enable the pupil to make connections with the acquired knowledge in his/her everyday life.</p>
            <p> संज्ञानात्मक बोध करवाना तथा भावनात्मक व मनोप्रेरणात्मक विकास करना | विद्यार्थियों को समर्थ बनाना ताकि वे प्राप्त ज्ञान का दैनिक जीवन से सम्बन्ध स्थापित कर उसका उपयोग कर सकें |</p>
            <p>Favoriser le développement cognitif, affectif et psychomoteur et permettre à l’élève d’établir des liens avec les connaissances acquises dans sa vie quotidienne.</p>
          </li>
        </ul>
        </div>
        </div>
        <div className='right-side'>
        <img src='../img/White-Color.webp'/>

    
        </div>
      </div>
    </div>
  )
}

export default mission
